import { RouteConfig } from 'vue-router';


const Role = () => import(/* webpackChunkName: "System" */  '../system/views/role/role.vue');
const UserList = () => import(/* webpackChunkName: "System" */  '../system/views/user/user-list.vue');
const HospitalList = () => import(/* webpackChunkName: "System" */  '../system/views/hospital/hospital-list.vue');
const ProductList = () => import(/* webpackChunkName: "System" */  '../system/views/product/product-list.vue');


const routers: RouteConfig[] = [
    {
        path: "role",
        component: Role
    },
    {
        path: "user-list",
        component: UserList
    },
    {
        path: "hospital-list",
        component: HospitalList
    },
    {
        path: "product-list",
        component: ProductList
    },
    {
        path: '',
        redirect: 'role'
    },
];

export default routers;
